var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShark = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M3.24 9.438a.2.2 0 0 0 .024.034zm15.443-4.333c.193-.835 1.43-2.079 1.621-3.092-1.662-1.132-4.717-.244-5.937 1.241-4.38-.314-8.25-.24-12.167.914C1.696 6.08 2.183 7.9 3.233 9.426c-.289-.46-.12-.775.329-.99.543-.259 1.495-.369 2.537-.404a17 17 0 0 1 1.19-.012h.006l.061.001.047.001.04.001.041.001.024.001c.714.02 1.468.073 2.22.155l.04.004c2.953.392 3.924.577 6.356 2.184a9.9 9.9 0 0 1 1.828 1.562l.007.01q0 .008.006.014.006.01.02.023-.001-.004-.005-.007l-.002-.004-.008-.012a5 5 0 0 1 .38.49c1.2 1.737 1.115 3.795.276 5.517l-.037.075q-.035.072-.073.142a7 7 0 0 1-.644.992l-.043.054a6.7 6.7 0 0 1-1.5 1.392l-.121.08-.088.054a5 5 0 0 1-.211.125l-.047.026-.064.035-.065.033a5.4 5.4 0 0 1-1.591.538c7.502-.816 12.025-9.775 4.541-16.402"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M13.706 20.897"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.004,
    d: "M6.188 5.621a.976.976 0 1 0 1.952.002.976.976 0 0 0-1.952-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "m17.97 11.955-.01-.015v.004q-.003.008.01.014l.016.02zm-4.264 8.941v.002zM3.24 9.438l.024.034a.2.2 0 0 1-.023-.034m10.004 12.127q.444.02.898-.059a10 10 0 0 1-.898.059m.462-.67v.002z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M17.965 11.954q.006.01.02.023l-.005-.007q-.007-.008-.015-.016m-2.023 8.901"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "m18.626 17.962-.037.074a7 7 0 0 1-.718 1.134l-.042.054a6.7 6.7 0 0 1-1.621 1.471l-.088.055a5.44 5.44 0 0 1-2.877.815c-.41 1.02-2.8 3.11-4.646 2.22a.25.25 0 0 1-.135-.265c.193-1.189 1.906-3.756 1.906-3.888 0 0-.784-2.503-.96-3.233a.38.38 0 0 1 .247-.453c1.419-.044 2.742 1.198 3.17 2.46.348.005 3.018-.197 3.028-1.534.185-1.304-.485-2.216-1.526-2.706-3.603-1.252-6.662 1.11-11.094-4.74-.244-.456-.081-.773.329-.99.543-.259 1.495-.368 2.537-.404q.346-.015.715-.015c1.203.013 2.377.115 2.954.167 2.953.392 3.924.578 6.356 2.184a9.9 9.9 0 0 1 1.827 1.562l.008.01q0 .008.006.014a.1.1 0 0 0 .02.024l-.007-.012-.008-.011a5 5 0 0 1 .38.49c1.177 1.71 1.11 3.781.276 5.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M6.814 8.016q-.369 0-.715.015c-1.042.036-1.994.146-2.537.405.664-.35 1.974-.435 3.252-.42M16.208 20.695q.06-.038.12-.079zM18.59 18.037l-.074.141zM16.328 20.616a6.7 6.7 0 0 0 1.501-1.392l.042-.054.042-.054q.34-.445.603-.938a6.67 6.67 0 0 1-2.187 2.438M3.264 9.471a.2.2 0 0 1-.023-.034zM17.986 11.978l-.015-.02q-.014-.008-.012-.014v-.003l.011.014z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 1.5h20.519V24H2z"
  })))));
};
export default SvgShark;